import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import ModuleSidebarLayout from "../inventory/components/ModuleSidebarLayout";
import { getDiagnosticDoctorCopy } from "../diagnostic-reports/diagnosticReportApi";
import { NAV_CONFIG } from "./constants";

export default function RadiologyLayout({ children }) {
  const history = useHistory();
  const roleType = String(sessionStorage.getItem("roleType") || "").toLowerCase();
  const navConfig = useMemo(() => {
    if (roleType !== "radiologist") return NAV_CONFIG;
    const copy = getDiagnosticDoctorCopy("radiologist");
    return {
      ...NAV_CONFIG,
      subtitle: copy.pageTitle,
      groups: NAV_CONFIG.groups.map((group) => ({
        ...group,
        items: group.items
          .filter(
            (item) => item.id !== "requisition" && item.id !== "templates"
          )
          .map((item) =>
            item.id === "studies" ? { ...item, label: copy.navLabel } : item
          ),
      })),
    };
  }, [roleType]);

  useEffect(() => {
    if (!sessionStorage.getItem("accessToken")) history.push("/login");
  }, [history]);

  return (
    <ModuleSidebarLayout
      navConfig={navConfig}
      suiteBase=""
      storageKey="rad_sidebar_expanded"
      disableContentPadding
    >
      {children}
    </ModuleSidebarLayout>
  );
}
